var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapToner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z",
    id: "mapToner_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mapToner_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mapToner_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M14-1H2a2.99 2.99 0 00-2.121.879A2.99 2.99 0 00-1 2v12c0 .828.336 1.578.879 2.121A2.99 2.99 0 002 17h12a2.99 2.99 0 002.121-.879A2.99 2.99 0 0017 14V2a2.99 2.99 0 00-.879-2.121A2.99 2.99 0 0014-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#mapToner_svg__b)",
    d: "M-4 20L20-4v24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A5AC",
    mask: "url(#mapToner_svg__b)",
    d: "M-4 20V-4h24z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 3H6a2.99 2.99 0 00-2.121.879A2.99 2.99 0 003 6v12c0 .828.336 1.578.879 2.121A2.99 2.99 0 006 21h12a2.99 2.99 0 002.121-.879A2.99 2.99 0 0021 18V6a2.99 2.99 0 00-.879-2.121A2.99 2.99 0 0018 3z",
    stroke: "#000",
    strokeWidth: 2
  }))));
}
export default __webpack_public_path__ + "static/media/caa185cd9ca7a9a195f575c024ee459d-mapToner.svg";
export { SvgMapToner as ReactComponent };